import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForCompanyName: {
        id: 'searchForCompanyName',
        defaultMessage: 'Please search for your company name'
    },
    manualCompanyToggle: {
        id: "Can't find the company?",
        defaultMessage: "Can't find the company?"
    },
    manualCompanyToggleLinkText: {
        id: 'Enter it manually',
        defaultMessage: 'Enter it manually'
    },
    companyNotFoundErrorTitle: {
        id: 'companyNotFoundErrorTitle',
        defaultMessage: "Oops. We couldn't find your company"
    },
    companyNotFoundErrorContent: {
        id: 'companyNotFoundErrorContent',
        defaultMessage:
            "Are you sure you have entered your registered company name? If you still can't find your company then"
    },
    searchForCompany: {
        id: 'searchForCompany',
        defaultMessage: 'Search for your company'
    },
    noSearchTermContent: {
        id: 'noSearchTermContent',
        defaultMessage:
            'Enter your full company name, as registered with Companies House'
    },
    warningTitle: {
        id: 'warningTitle',
        defaultMessage: 'Oops. Something went wrong'
    },
    warningContent: {
        id: 'warningContent',
        defaultMessage: 'Please try to enter your company'
    },
    warningLinkText: {
        id: 'warningLinkText',
        defaultMessage: 'manually'
    },
    searchForMyCompany: {
        id: 'searchForMyCompany',
        defaultMessage: 'Search for my company'
    },
    chooseCompanyHelperText: {
        id: 'chooseCompanyHelperText',
        defaultMessage: 'Choose your company (or {manualEntryLink})'
    },
    chooseCompanyLinkText: {
        id: 'chooseCompanyLinkText',
        defaultMessage: 'enter manually'
    },
    filterMoreResultsText: {
        id: 'filterMoreResultsText',
        defaultMessage:
            'For more results, enter your postal code and select your company (or {manualEntryLink})'
    },
    filterMoreResultsLink: {
        id: 'filterMoreResultsLink',
        defaultMessage: 'manually enter your company data'
    },
    searchPlaceholder: {
        id: 'searchPlaceholder',
        defaultMessage: 'Search...'
    },
    companyName: {
        id: 'companyName',
        defaultMessage: 'Company Name'
    },
    companyNumber: {
        id: 'companyNumber',
        defaultMessage: 'Company Number'
    },
    companyNumberType: {
        id: 'companyNumberType',
        defaultMessage: 'Type'
    },
    businessAddress: {
        id: '_.address.business_address',
        defaultMessage: 'Your business address'
    }
});
